import { memo } from 'react'
import CurrencyAndLocationModal from './CurrencyAndLocationModal'
import CurrencyAndLocationButton from './CurrencyAndLocationButton'
import { useCurrencyAndLocationController } from './CurrencyAndLocation.controller'

function CurrencyAndLocation() {
  const { isModalOpen, setIsModalOpen, selectedCurrency, onSelectCurrency } =
    useCurrencyAndLocationController()

  return (
    <>
      <CurrencyAndLocationButton
        data={selectedCurrency}
        onClick={() => {
          setIsModalOpen(true)
        }}
      />
      <CurrencyAndLocationModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
        }}
        data={selectedCurrency}
        onSelectCurrency={onSelectCurrency}
      />
    </>
  )
}

export default memo(CurrencyAndLocation)
